export const best_time = () => (
  <path
    d="M8 3H5a2 2 0 00-2 2v4m5-6h8M8 3V1m0 2v2m8-2h3a2 2 0 012 2v4m-5-6V1m0 2v2M8 21H5a2 2 0 01-2-2V9m0 0h9m4.5 2l2.009 3.95 4.491.637-3.25 3.072.767 4.341-4.017-2.05L12.483 23l.767-4.34L10 15.586l4.492-.637L16.5 11z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
